export default __webpack_public_path__ + "static/media/rocket_anim_55.1d8c474a.png";